import { InjectionToken, ValueProvider } from '@angular/core';
import { API_DEVELOPMENT_ACTUAR, APP_URL_DEVELOPMENT, EXTERNAL_URL_DEVELOPMENT } from './env/environment.development';
import { API_PRODUCTION_ACTUAR, APP_URL_PRODUCTION, EXTERNAL_URL_PRODUCTION } from './env/environment.production';
import { API_LOCAL_ACTUAR, APP_URL_LOCAL, EXTERNAL_URL_LOCAL } from './env/environment';
import { API_STAGE_ACTUAR, APP_URL_STAGE, EXTERNAL_URL_STAGE } from './env/environment.stage';
import { API_RELEASE_ACTUAR, APP_URL_RELEASE, EXTERNAL_URL_RELEASE } from './env/environment.release';

export type Environment = 'local' | 'dev' | 'stage' | 'prod' | 'rc';

export type AppConfig = {
  version: string;
  apiUrl: ApiUrlsType;
  externalUrl: ExternalUrlsType;
  environment: Environment;
  appSource: AppSource;
  appUrl: APP_URLType;
};

export enum AppSource {
  None = 0,
  Actuar = 1,
  Treino = 2,
  Afig = 3,
  FacilFit = 4,
  PagueLa = 5,
  Accounts
}

export enum AppVersion {
  Old = 0,
  New = 1
}

export enum App_url_type_by_AppSource_enum {
  "Actuar" = "actuar_app",
  "Treino" = "treino_app",
  "Afig" = "afig_app",
  "FacilFit" = "facilfit_app",
  "PagueLa" = "pague_la_app",
  "Accounts" = "accounts",
}

export type APP_URLType = {
  accounts: string;
  actuar_app: string;
  treino_app: string;
  actuar_sign: string;
  afig_app: string;
  actuar_acesso: string;
  facilfit_app: string;
  face_detection_app: string;
}

export type AppUrlOptions =
  "accounts"|
  "actuar_app"|
  "treino_app"|
  "actuar_sign"|
  "afig_app"|
  "actuar_acesso"|
  "facilfit_app"|
  "face_detection_app";

export type ApiUrlsType = {
  odata: string;
  odata_goods_service: string;
  odata_person_service: string;
  odata_payable_service: string;
  odata_work_service: string;
  odata_crm_service: string;
  odata_generalfinance_service: string;
  odata_account_service: string;
  odata_receivable_service: string;
  odata_email_service: string;
  odata_contract: string;
  odata_user_service: string;
  odata_workout_service: string;
  odata_post_service: string;
  odata_activity_service: string;
  odata_addresses_service: string;
  odata_booking_service: string;
  odata_graduation_service: string;
  odata_subscription_service: string;
  odata_data_service: string;
  odata_physical_assessment_service: string;
  odata_helpdesk_service: string;
  odata_hotsite_service: string;
  odata_consumption_log_service: string;
  odata_access_log_service: string;
  base: string;
  paguela: string;
  api_cep: string;
  auth: string;
  chat: string;
  file_manager: string;
  treino: string;
  facial: string;
  acesso: string;
  caixa: string;
  helpdesk: string;
  ajustes: string;
  files_api: string;
  contract: string;
  billing: string;
  gympass: string;
  client_notification: string;
  invoicer: string;
  acessoLocalhost: string;
  account_service: string;
  userService: string;
  personService: string;
  file_group: string;
  goods: string;
  payable_service: string;
  workService: string;
  crm_service: string;
  generalfinance_service: string;
  receivable_service: string;
  subscription_service: string;
  email_service: string;
  consummation: string;
  workout_service: string;
  workout_view: string;
  post_service: string;
  activity_service: string;
  booking_service: string;
  data_service: string;
  addresses_service: string;
  storage_service: string;
  physical_assessment_service: string;
  whatsapp_service: string;
  hotsite: string;
  graduation_service: string;
  totalpass: string;
  storage: string;
  search_service: string;
  file_group_service: string;
  hotsite_service: string;
  credit_assessment_service: string;
  meetings_service: string;
  access_service: string;
  access_directory_service: string;
  consumption_log_service: string;
  consumption_auth_service: string;
  spooler: string;
  access_edge_manager_service: string;
  access_edge_manager_service_grpc: string;
  access_log_service: string;
};

export type ExternalUrlsType = {
  pague_la: string;
  sign_view: string;
}

export const ProductionEnv: ApiUrlsType  = API_PRODUCTION_ACTUAR;
export const DevelopmentEnv: ApiUrlsType = API_DEVELOPMENT_ACTUAR;
export const ReleaseEnv: ApiUrlsType = API_RELEASE_ACTUAR;
export const LocalEnv: ApiUrlsType  = API_LOCAL_ACTUAR;
export const StageEnv: ApiUrlsType  = API_STAGE_ACTUAR;
export const LocalAppUrl: APP_URLType = APP_URL_LOCAL;
export const ProductionAppUrl: APP_URLType = APP_URL_PRODUCTION;
export const DevelopmentAppUrl: APP_URLType = APP_URL_DEVELOPMENT;
export const StageAppUrl: APP_URLType = APP_URL_STAGE;
export const ReleaseAppUrl: APP_URLType = APP_URL_RELEASE;
export const LocalExternalUrl = EXTERNAL_URL_LOCAL;
export const ProductionExternalUrl = EXTERNAL_URL_PRODUCTION;
export const DevelopmentExternalUrl = EXTERNAL_URL_DEVELOPMENT;
export const StageExternalUrl = EXTERNAL_URL_STAGE;
export const ReleaseExternalUrl = EXTERNAL_URL_RELEASE;

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');

export const EXTERNAL_APIS = { ipApi: 'https://ipapi.co/json'};

export const GOOGLE_MAPS_CONFIG = {
  apiKey: 'AIzaSyCjETHiVAXDHYEb7gXbS9O7dTgMnyndZEQ',
  libraries: ['places'],
};

export const AppConfigProvider = (config: AppConfig): ValueProvider => ({
  provide: APP_CONFIG,
  useValue: config,
});

export const adminTenants = [
  {
    account: 'd2467ad2-8f94-48e8-a938-8355af6b55da',
    name: 'K11',
    blipPassword: '12345'
  },
  {
    account: 'eb7689de-62b1-4e1b-98aa-86ee648bfe91',
    name: 'Actuar',
  },
  {
    account: '77a6bd71-6836-49e7-9f1b-90403fbca069',
    name: 'Treino',
  },
  {
    account: 'f8f293ac-1498-438a-9e60-11d1e8a36c0d',
    name: 'Afig'
  },
  {
    account: '9546e583-6fb6-46bc-aa5f-e49f202d9397',
    name: 'Catracaparaacademia'
  },
  {
    account: '44cc6127-5197-401d-a68d-3bc9a2f4fe3e',
    name: 'Paguela'
  },
  {
    account: '09d6f13e-80c9-4090-b493-6ad3a0ffab1d',
    name: 'ActPaguela'
  },
  {
    account: '95a38624-54bd-4042-8b4e-bfcc3096fb08',
    name: 'ActuarPaguela'
  },
  {
    account: '9c1c84e1-b076-4721-bf60-815d5a208e12',
    name: 'Facilfit'
  },
  {
    account: '8aa780a2-e516-42c4-a928-3b1802fbffdc',
    name: 'Toletus'
  },
];

export const devExtremeKey = 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjAwNDVjNWIzLWM3NGQtNDFhNi05MzE5LTRjY2M0YWVkNzU3YyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.ZxM4fzXdIr+ZYNdrF+I9hvM3grAjT3RPckE0ffxHO8BHEUdDB+v+ABNP+/U+0Z7jd3jwgOmth55B58xy+Zz3R9U7ntDpbw1xxM/gA/VxsUNO3R+GvGFDfjtn56E3QcZTvGzaKQ==';
